import React from 'react';
import './Congrat.css';
import {Modal} from 'react-bootstrap'

const getDepositLink = (isAcy) => {
	const host = window.location.host;
	const regulation = isAcy ? "ltd" : "au";
	const domain = () => {
		switch(host){
			case "acyasia-cn.com":
				return "acycn"
			case "acyasia-vn.com":
				return "acyvn"
			default:
				return "acy"
			}
	}
	return `https://secure.${regulation}.${domain()}.cloud/#/fund-manager/deposite-funds`
};

const MakeDeposit = 
({text, show, closePop, url, lang}) => {
    return (
        <Modal show={show} onHide={() => closePop('deposit')} size="lg" centered className={`deposit-modal my-modal ${lang}`}>
            <Modal.Header closeButton={true}>
            </Modal.Header>
            <Modal.Body>
                <h3>{text.title}</h3>
                <p>{text.p1}</p>
                <p>{text.p2}</p>
                
                <a href={getDepositLink(url === "ACY")} target='_blank'  className="modal-btn">{text.button}</a>
            </Modal.Body>
        </Modal>

    );
};
export default MakeDeposit
